export default __webpack_public_path__ + "static/media/total-discharge.3e833449.svg";